import React, { useEffect } from 'react';
import { TipTapEditor } from '../TipTap';
import './DisplayDatabaseContent.css';

function DisplayDatabaseContent({
  data,
  getDataFromComponent,
}) {
  useEffect(() => {
    getDataFromComponent(data.data, data.key, data.question_text, data.data);
  }, []);

  const getStringValue = () => {
    try {
      return String(data.data);
    } catch (e) {
      return '';
    }
  };

  return (
    <div
      className="tiptap-custom-wrapper"
      style={{
        marginTop: '1rem',
      }}
    >
      <TipTapEditor
        value={getStringValue()}
        readOnly={true}
        showToolbar={false}
        minHeight="0px"
      />
    </div>
  );
}

export default DisplayDatabaseContent;
